<template>
    <component :is="component" v-if="localized" v-bind="$props" />
    <ResponsiveImage :image-url="provider.logo" width="76px" class="logo" v-else/>
</template>

<script>
    import LocalizedComponentMixin from "@/components/localization/LocalizedComponentMixin";

    export default {
        name: "PaymentPlanImage",
        mixins: [
            LocalizedComponentMixin,
        ],
        props: {
            provider: {
                type: Object,
                required: true,
            },
            paymentPlan: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                componentType: "paymentPlanImage",
            }
        },
    }
</script>
